import { Center } from "@chakra-ui/react";
import { SimpleList } from "@/components/list";

export const INTRO_CONSTANTS = {
  title: "Why Move to OneMind PaaS ",
  text: "Modern development teams thrive when infrastructure doesn’t get in their way. OneMind PaaS eliminates the complexities of managing Kubernetes at scale by delivering:",
  children: (
    <Center bgColor={"gray.100"} p={6} borderRadius={"lg"} color="black">
      <SimpleList
        points={[
          "Zero-ops experience through a fully managed control plane",
          "Faster innovation cycles with native observability and built-in automation",
          "Enterprise-grade reliability without the DIY headaches",
        ]}
      />
    </Center>
  ),
  concText:
    " From startups to large enterprises, OneMind PaaS empowers teams to build, ship , and scale applications faster — while we take care of the platform.",
};
